import { OutcomesTourTarget } from "consts";

/** Marks an area the results-page tour can highlight. Typed, so a misspelt target fails to compile. */
export const tourTargetProps = (target: OutcomesTourTarget) => ({ "data-tour-target": target });

/** On screen: attached, laid out (not display: none) and not visibility: hidden. */
export const isRendered = (element: Element) =>
  element.isConnected && element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== "hidden";

export const findTourTarget = (root: HTMLElement | null, target: OutcomesTourTarget): HTMLElement | null =>
  Array.from(root?.querySelectorAll<HTMLElement>(`[data-tour-target="${target}"]`) ?? []).find(isRendered) ?? null;
